import {
  IsEnum,
  IsNotEmpty,
  IsOptional,
  IsString,
  IsUUID,
} from 'class-validator';
import { PaymentProcessor } from '@pflegenavi/shared/api';

export class AcceptInvitationBodyDto {
  @IsNotEmpty()
  @IsString()
  tenant!: string;

  @IsNotEmpty()
  @IsUUID(4)
  globalServiceProviderId!: string;

  @IsNotEmpty()
  @IsUUID(4)
  nursingHomeId!: string;
}

export class RejectInvitationBodyDto {
  @IsNotEmpty()
  @IsString()
  tenant!: string;

  @IsNotEmpty()
  @IsUUID(4)
  globalServiceProviderId!: string;

  @IsNotEmpty()
  @IsUUID(4)
  nursingHomeId!: string;
}

export enum ConnectionStatus {
  InvitePending = 'invite_pending',
  Active = 'active',
  Inactive = 'inactive',
  InviteRejected = 'invite_rejected',
}

export class NursingHomeListResultDto {
  @IsNotEmpty()
  @IsString()
  nursingHomeId!: string;

  @IsNotEmpty()
  @IsString()
  nursingHomeName!: string;

  @IsNotEmpty()
  @IsString()
  globalServiceProviderId!: string;

  @IsNotEmpty()
  @IsEnum(ConnectionStatus)
  connectionStatus!: ConnectionStatus;

  @IsNotEmpty()
  @IsString()
  tenant!: string;

  @IsOptional()
  @IsEnum(PaymentProcessor)
  paymentProcessor?: PaymentProcessor;
}

export const OnboardingControllerDefinition = {
  controller: 'onboarding',
  endpoints: {
    acceptInvitation: {
      method: 'POST',
      url: 'invitation/accept',
      response: undefined as unknown as { success: true },
      body: undefined as unknown as AcceptInvitationBodyDto,
      query: undefined,
    },
    rejectInvitation: {
      method: 'POST',
      url: 'invitation/reject',
      response: undefined as unknown as { success: true },
      body: undefined as unknown as RejectInvitationBodyDto,
      query: undefined,
    },
    getNursingHomeList: {
      method: 'GET',
      url: 'nursing-home',
      response: undefined as unknown as NursingHomeListResultDto[],
      body: undefined,
      query: undefined,
    },
  },
} as const;

export type OnboardingControllerResultTypes = {
  [key in keyof (typeof OnboardingControllerDefinition)['endpoints']]: (typeof OnboardingControllerDefinition)['endpoints'][key]['response'];
};
export type OnboardingControllerQueryTypes = {
  [key in keyof (typeof OnboardingControllerDefinition)['endpoints']]: (typeof OnboardingControllerDefinition)['endpoints'][key]['query'];
};
export type OnboardingControllerBodyTypes = {
  [key in keyof (typeof OnboardingControllerDefinition)['endpoints']]: (typeof OnboardingControllerDefinition)['endpoints'][key]['body'];
};
